import { render } from "./TosolaConcept.vue?vue&type=template&id=466880f4&scoped=true"
import script from "./TosolaConcept.vue?vue&type=script&lang=js"
export * from "./TosolaConcept.vue?vue&type=script&lang=js"

import "./TosolaConcept.vue?vue&type=style&index=0&id=466880f4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466880f4"]])

export default __exports__